/*
  assets/nibec-cart-vacio-cro.js · Bigbuda T-0789 (17-oct-2026)
  Carrito vacío del cajón (snippets/nibec-cart-vacio-cro.liquid):
  1) «Agregar» suma 1 unidad con POST a /cart/add y abre el cajón con el carrito ya lleno (mismo flujo que
     product-form.js: pide las secciones del cajón y llama a cart-drawer.renderContents). Sin crear un
     <product-form>, porque product-form.js define el elemento y cargarlo dos veces lo rompe.
  2) Mide cada clic: nibec_carrito_vacio_click (Shopify.analytics y dataLayer) con tipo (producto, categoria,
     cotizar, garantia, agregar), destino y posición. Heatmap lee data-hm-id.
  3) Ronda 2 (T-0817, 17-oct-2026), solo con «Cajón compacto en celular» (clase nibec-vc--compacto):
     - marca is-mas-abajo en el contenedor cuando hay más contenido bajo el borde (degradado al pie) y
       is-mas-derecha / is-mas-izquierda en la fila de categorías (degradado lateral);
     - mide nibec_carrito_vacio_vista (al abrir el cajón vacío: alto de pantalla, si necesita desplazarse, cuántos
       productos y categorías caben) y nibec_carrito_vacio_scroll (primera vez que se desliza, zona vertical o
       categorias) para saber si el aviso funciona;
     - con el teclado, desliza la categoría enfocada hasta dejarla entera a la vista.
  Se carga con defer solo si el interruptor está encendido. Delegación en document: sigue funcionando cuando
  el cajón se redibuja vacío sin recargar la página.
*/
(function () {
  if (window.__nibecCartVacioCro) return;
  window.__nibecCartVacioCro = true;

  function medir(tipo, el) {
    var datos = {
      tipo: tipo,
      destino: el.getAttribute('data-nibec-vc-dato') || '',
      posicion: parseInt(el.getAttribute('data-nibec-vc-pos'), 10) || 0,
      dispositivo: window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'celular' : 'computador'
    };
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('nibec_carrito_vacio_click', datos);
    } catch (err) {}
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'nibec_carrito_vacio_click' }, datos));
    } catch (err) {}
  }

  function agregar(boton) {
    var cart = document.querySelector('cart-drawer');
    if (!cart || typeof cart.renderContents !== 'function' || boton.getAttribute('aria-busy') === 'true') return;
    boton.setAttribute('aria-busy', 'true');
    var textoOriginal = boton.textContent;
    boton.textContent = 'Agregando…';
    var estado = boton.closest('[data-nibec-vc]') && boton.closest('[data-nibec-vc]').querySelector('[data-nibec-vc-estado]');
    if (estado) estado.textContent = 'Agregando al carrito';

    var cuerpo = new FormData();
    cuerpo.append('id', boton.getAttribute('data-nibec-vc-agregar'));
    cuerpo.append('quantity', '1');
    cuerpo.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    cuerpo.append('sections_url', window.location.pathname);
    if (cart.setActiveElement) cart.setActiveElement(document.activeElement);

    fetch(window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: cuerpo
    })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp.status || !resp.sections) throw new Error(resp.description || 'sin secciones');
        cart.renderContents(resp);
      })
      .catch(function () {
        boton.removeAttribute('aria-busy');
        boton.textContent = 'No se pudo agregar. Reintentar';
        if (estado) estado.textContent = 'No se pudo agregar el producto. Intenta de nuevo.';
        setTimeout(function () { boton.textContent = textoOriginal; }, 4000);
      });
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var ag = t.closest('[data-nibec-vc-agregar]');
      if (ag) {
        medir('agregar', ag);
        agregar(ag);
        return;
      }
      var link = t.closest('[data-nibec-vc-click]');
      if (link) medir(link.getAttribute('data-nibec-vc-click'), link);
    },
    true
  );

  // ---- Ronda 2 · T-0817: indicios de desplazamiento y medición del cajón compacto ----
  var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ro = null;
  var vistoEnEstaApertura = false;
  var scrollMedido = { vertical: false, categorias: false };

  function publicar(nombre, datos) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nombre, datos);
    } catch (err) {}
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: nombre }, datos));
    } catch (err) {}
  }

  function area() {
    return document.querySelector('cart-drawer .nibec-vc--compacto');
  }

  function actualizarIndicios() {
    var a = area();
    if (!a) return;
    var caja = a.parentElement;
    if (caja) caja.classList.toggle('is-mas-abajo', a.scrollTop + a.clientHeight < a.scrollHeight - 4);
    var f = a.querySelector('[data-nibec-vc-cats]');
    if (f) {
      f.classList.toggle('is-mas-derecha', f.scrollLeft + f.clientWidth < f.scrollWidth - 4);
      f.classList.toggle('is-mas-izquierda', f.scrollLeft > 4);
    }
  }

  function observar() {
    var a = area();
    if (!a) return;
    if (ro) ro.disconnect();
    if (window.ResizeObserver) {
      ro = new ResizeObserver(actualizarIndicios);
      ro.observe(a);
      var f = a.querySelector('[data-nibec-vc-cats]');
      if (f) ro.observe(f);
      Array.prototype.forEach.call(a.children, function (h) { ro.observe(h); });
    }
    actualizarIndicios();
  }

  function medirVista() {
    var a = area();
    if (!a || vistoEnEstaApertura) return;
    vistoEnEstaApertura = true;
    var visibles = Array.prototype.filter.call(a.querySelectorAll('.nibec-vc__item'), function (i) { return i.offsetParent !== null; }).length;
    var cats = a.querySelectorAll('.nibec-vc__cats > li');
    var f = a.querySelector('[data-nibec-vc-cats]');
    publicar('nibec_carrito_vacio_vista', {
      alto_pantalla: window.innerHeight,
      ancho_pantalla: window.innerWidth,
      necesita_scroll: a.scrollHeight > a.clientHeight + 4 ? 'si' : 'no',
      productos_visibles: visibles,
      categorias: cats.length,
      categorias_con_scroll: f && f.scrollWidth > f.clientWidth + 4 ? 'si' : 'no',
      dispositivo: window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'celular' : 'computador'
    });
  }

  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (!t || !t.classList) return;
      if (t.classList.contains('nibec-vc--compacto')) {
        actualizarIndicios();
        if (!scrollMedido.vertical && t.scrollTop > 8) {
          scrollMedido.vertical = true;
          publicar('nibec_carrito_vacio_scroll', { zona: 'vertical', alto_pantalla: window.innerHeight });
        }
      } else if (t.hasAttribute && t.hasAttribute('data-nibec-vc-cats')) {
        actualizarIndicios();
        if (!scrollMedido.categorias && t.scrollLeft > 8) {
          scrollMedido.categorias = true;
          publicar('nibec_carrito_vacio_scroll', { zona: 'categorias', alto_pantalla: window.innerHeight });
        }
      }
    },
    true
  );

  // Con el teclado, la categoría enfocada se desliza hasta quedar entera a la vista (el navegador no mueve las que asoman cortadas).
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('[data-nibec-vc-cats]') || !t.scrollIntoView) return;
    try { t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reducir ? 'auto' : 'smooth' }); } catch (err) {}
  });

  function iniciar() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    observar();
    // El cajón se vuelve a dibujar (agregar, quitar, vaciar): se vuelven a enganchar los indicios.
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        var abrioOCerro = muts.some(function (m) { return m.type === 'attributes' && m.target === cd; });
        var redibujo = muts.some(function (m) { return m.type === 'childList'; });
        if (abrioOCerro) {
          if (cd.classList.contains('active')) {
            window.setTimeout(function () { observar(); medirVista(); }, reducir ? 0 : 120);
          } else {
            vistoEnEstaApertura = false;
          }
        }
        if (redibujo) observar();
      }).observe(cd, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    }
    window.addEventListener('resize', actualizarIndicios);
    if (cd.classList.contains('active')) medirVista();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
